// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort-icon[data-v-2006282a]{margin-left:15px}", ""]);
// Exports
module.exports = exports;
